import { useCallback, useState } from 'react'
import PropTypes from 'prop-types'
import { Checkbox } from 'antd'
import isNil from 'lodash/isNil'
import { getDomicileCountries } from '~/actions/onboarding'

const onshore = 'Onshore (US)'
const offshore = 'Offshore'

const DomicileSection = ({ value, onChange, isRequired }) => {
  const transformValueToDomicile = () => {
    if (value === null) return []
    const result = []
    const valueSplit = value?.split(',')
    if (!isNil(valueSplit?.find((x) => x === onshore))) result.push(onshore)
    if (!isNil(valueSplit?.find((x) => x === offshore))) result.push(offshore)
    return result
  }

  const transformValueToCountries = () => {
    const domicile = transformValueToDomicile()
    if (!isNil(domicile.find((x) => x === offshore))) {
      const valueSplit = value?.split(',')
      return valueSplit.filter((x) => x !== onshore && x !== offshore)
    }
    return []
  }

  const [countries, setCountries] = useState()
  const [countriesLoading, setCountriesLoading] = useState(false)
  const [selectedDomicile, setSelectedDomicile] = useState(
    transformValueToDomicile()
  )
  const [selectedCountries, setSelectedCountries] = useState(
    transformValueToCountries()
  )
  const [allCountriesSelected, setAllCountriesSelected] = useState(false)

  if (isNil(countries) && countriesLoading === false) {
    setCountriesLoading(true)
    getDomicileCountries().then((response) => {
      setCountries(response.data.result)
      setCountriesLoading(false)
    })
  }

  const onAllChanged = useCallback(
    (domicile = [], countries = []) => {
      let result = ''
      if (!isNil(domicile.find((x) => x === onshore))) result = onshore

      if (!isNil(domicile.find((x) => x === offshore))) {
        result = result === '' ? offshore : `${result},${offshore}`
        if (countries.length > 0) result = `${result},${countries.join(',')}`
      }
      onChange(result)
    },
    [onChange]
  )

  const onDomicileChanged = (value) => {
    const hasOffshore = isNil(value.find((x) => x === offshore))
    if (hasOffshore) {
      setSelectedCountries([])
      setAllCountriesSelected(false)
      onAllChanged()
    }
    setSelectedDomicile(value)
    onAllChanged(value, selectedCountries)
  }

  const onCountryChanged = (value) => {
    setSelectedCountries(value)
    onAllChanged(selectedDomicile, value)
    setAllCountriesSelected(false)
  }

  const allCountriesChanged = (e) => {
    const { checked } = e.target

    setAllCountriesSelected(checked)
    if (checked) {
      setSelectedCountries(countries)
      onAllChanged(selectedDomicile, countries)
    } else {
      setSelectedCountries([])
      onAllChanged(selectedDomicile, [])
    }
  }

  const options = [onshore, offshore]

  return (
    <div>
      <div className="cc-generic-form-checkbox-group">
        <span className="cc-heading6 cc-generic-form-checkbox-header">
          Fund Domicile Interest {isRequired === true ? ' *' : ''}
        </span>
        <Checkbox.Group
          onChange={onDomicileChanged}
          value={selectedDomicile}
          options={options.map((x) => ({
            label: x,
            value: x,
          }))}
        />

        {isNil(selectedDomicile.find((x) => x === offshore)) ? null : (
          <div className="cc-domicile-countries">
            <Checkbox
              className="cc-domicile-all-countries-checkbox"
              onChange={allCountriesChanged}
              checked={allCountriesSelected}
            >
              All Countries
            </Checkbox>
            <Checkbox.Group
              onChange={onCountryChanged}
              value={selectedCountries}
              options={
                countries &&
                countries.map((x) => ({
                  label: x,
                  value: x,
                }))
              }
            />
          </div>
        )}
      </div>
    </div>
  )
}

DomicileSection.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  isRequired: PropTypes.bool,
}

export default DomicileSection
